import React from "react"
import { Outlet } from "react-router-dom"

export const RootLayout = (): React.JSX.Element => {
  return <Outlet />
}

// TDO
